import { MyGrades } from './../../models/pages/mygrades';
import { IAction } from './../../models/action/core.d';
import { actions } from '../constants/gradebook';
import * as actionTypes from '../../models/action/gradebook';
import * as types from '../../models/pages/gradebook';

export function saveGradeBook(grades: types.IGradeBookItem[]) : actionTypes.IGradeBookSaveAction {
    return {
        grades,
        timestamp: Date.now(),
        type: actions.GRADEBOOK_SAVE
    };
}

export function GetMyGradebook(spinnerId?: string, spinnerType?: any, callback?: any) : IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_GRADEBOOK,
        callback
    };
}

export function SetMyGradebook(myGrades: MyGrades, spinnerId?: string, spinnerType?: any) : actionTypes.ISetMyGradebookAction {
    return {
        myGrades,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_GRADEBOOK,
    };
}
